import { Modal } from '@seiue/ui'
import styled from 'styled-components'

import { Outline } from 'packages/sdks-next/growp'

import { SortGroupModalContent } from './SortOutlinesModalContent'

/**
 * 打开分组排序弹窗
 *
 * @param param0 - 参数
 * @param param0.outlines - 课程章节
 */
export const openSortOutlines = ({ outlines }: { outlines: Outline[] }) => {
  const { hide } = Modal.open({
    title: (
      <Title>
        <TitleLabel>{'分组排序'}</TitleLabel>
        <SubTitle>{'拖动调整顺序'}</SubTitle>
      </Title>
    ),
    footer: null,
    bodyStyle: { padding: 0, overflow: 'hidden' },
    width: 480,
    children: (
      <SortGroupModalContent
        hide={() => hide()}
        outlines={outlines}
      />
    ),
  })
}

const Title = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

const TitleLabel = styled.div`
  color: ${(p) => p.theme.text._1};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`

const SubTitle = styled.div`
  color: ${(p) => p.theme.text._3};
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
`
